import React from 'react';

interface IconNoteProps {
  className?: string;
  color?: string;
  size?: number;
}

const IconNote: React.FC<IconNoteProps> = ({ className = '', color = '#4E66EC', size = 25 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path
        d="M16.1968 20.7274C15.9368 20.7274 15.6668 20.7174 15.3768 20.6874C14.8568 20.6474 14.2668 20.5474 13.6568 20.3974L11.9768 19.9974C7.36677 18.9074 5.85677 16.4674 6.93677 11.8674L7.91677 7.67738C8.13677 6.72738 8.39677 5.95738 8.71677 5.31738C10.4368 1.76738 13.7268 2.08738 16.0668 2.63738L17.7368 3.02738C20.0768 3.57738 21.5568 4.44738 22.3868 5.77738C23.2068 7.10738 23.3368 8.81738 22.7868 11.1574L21.8068 15.3374C20.9468 18.9974 19.1568 20.7274 16.1968 20.7274ZM13.5068 3.79738C11.8368 3.79738 10.7768 4.48738 10.0668 5.96738C9.80677 6.50738 9.57677 7.17738 9.37677 8.01738L8.39677 12.2074C7.50677 15.9874 8.53677 17.6374 12.3168 18.5374L13.9968 18.9374C14.5368 19.0674 15.0468 19.1474 15.5068 19.1874C18.2268 19.4574 19.5768 18.2674 20.3368 14.9974L21.3168 10.8174C21.7668 8.88738 21.7068 7.53738 21.1068 6.56738C20.5068 5.59738 19.3268 4.93738 17.3868 4.48738L15.7168 4.09738C14.8868 3.89738 14.1468 3.79738 13.5068 3.79738Z"
        fill="currentColor"
      />
      <path
        d="M8.71677 22.7974C6.14677 22.7974 4.50677 21.2574 3.45677 18.0074L2.17677 14.0574C0.75677 9.65738 2.02677 7.17738 6.40677 5.75738L7.98677 5.24738C8.50677 5.08738 8.89677 4.97738 9.24677 4.91738C9.53677 4.85738 9.81677 4.96738 9.98677 5.19738C10.1568 5.42738 10.1868 5.72738 10.0668 5.98738C9.80677 6.51738 9.57677 7.18738 9.38677 8.02738L8.40677 12.2174C7.51677 15.9974 8.54677 17.6474 12.3268 18.5474L14.0068 18.9474C14.5468 19.0774 15.0568 19.1574 15.5168 19.1974C15.8368 19.2274 16.0968 19.4474 16.1868 19.7574C16.2668 20.0674 16.1468 20.3874 15.8868 20.5674C15.2268 21.0174 14.3968 21.3974 13.3468 21.7374L11.7668 22.2574C10.6168 22.6174 9.61677 22.7974 8.71677 22.7974ZM8.16677 6.76738L6.87677 7.18738C3.30677 8.33738 2.45677 10.0174 3.60677 13.5974L4.88677 17.5474C6.04677 21.1174 7.72677 21.9774 11.2968 20.8274L12.8768 20.3074C12.9368 20.2874 12.9868 20.2674 13.0468 20.2474L11.9868 19.9974C7.37677 18.9074 5.86677 16.4674 6.94677 11.8674L7.92677 7.67738C7.99677 7.35738 8.07677 7.04738 8.16677 6.76738Z"
        fill="currentColor"
      />
      <path
        d="M17.8768 11.0574C17.8168 11.0574 17.7568 11.0474 17.6868 11.0374L12.8368 9.80738C12.4368 9.70738 12.1968 9.29738 12.2968 8.89738C12.3968 8.49738 12.8068 8.25738 13.2068 8.35738L18.0568 9.58738C18.4568 9.68738 18.6968 10.0974 18.5968 10.4974C18.5168 10.8274 18.2068 11.0574 17.8768 11.0574Z"
        fill="currentColor"
      />
      <path
        d="M14.9468 14.4374C14.8868 14.4374 14.8268 14.4274 14.7568 14.4174L11.8468 13.6774C11.4468 13.5774 11.2068 13.1674 11.3068 12.7674C11.4068 12.3674 11.8168 12.1274 12.2168 12.2274L15.1268 12.9674C15.5268 13.0674 15.7668 13.4774 15.6668 13.8774C15.5868 14.2174 15.2868 14.4374 14.9468 14.4374Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default IconNote;
